import React, { Component } from 'react';
import { connect } from "react-redux";
import { Modal } from 'reactstrap';
import * as types from "../../../constants/actionTypes";
import AdultProxyAttestation from './request/AdultProxyAttestation';
import { withRouter, Link, Redirect } from 'react-router-dom';
import { PROXY_PENDING, EPIC, REQUESTV2, REQUEST, RX } from "../../../constants/textConstants";
import Spinner from '../../common/spinner';
import * as ProxyHelper from "../../proxyManagement/ProxyHelper";
import StatusBanner from '../../common/StatusBanner';
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import MyChartNotFound from '../MyChartNotFound';
import { getAge } from "../../../helpers/dateTime";
import PharmacyNotFound from "../PharmacyNotFound";

const mainHeading = "To approve access, read and agree to the terms";
const subHeading = "Follow the links to read the";
const DATEOFBIRTHINVALID = "The date of birth provided in the request doesn't match your account.";


class ProxyTermsV2 extends Component {
    constructor(props) {
        super(props);
        const { action, proxyRequestId, proxySource, proxyName, requestType } = this.props.match.params;       

        this.state = {
            showModal: false,
            action: action,
            proxyRequestId: proxyRequestId,
            proxySource: proxySource,
            proxyName: proxyName,
            requestType: requestType,
            showV2Terms: true,
            errorMessage: "",
            url: "",
            status: "",
            changeRequestStatusPending: false,
            pharmacyLinked: this.props.hasPharmacyLogin,
            showManageAccountAccess: false
        }
        this.changeRequestPendingCallback = this.changeRequestPendingCallback.bind(this);         
        this.proxyDetailsCallback = this.proxyDetailsCallback.bind(this);
        this.props.getProxyDetails(proxyRequestId, this.proxyDetailsCallback);
        this.onDeclineClick = this.onDeclineClick.bind(this);
        this.onAcceptClick = this.onAcceptClick.bind(this);
        this.onRxLinked = this.onRxLinked.bind(this);
        this.gotItCallback = this.gotItCallback.bind(this);       
    }

    componentDidMount() {
        this.mounted = true;
        logUI("MBHWeb.UI.ProxyTermsV2.ComponentDidMount", new Date(), Tools.getURLPath());
        this.getProxyTermsAndConditions();       
    }

    componentWillUnmount() {
        this.mounted = false;
    }
    proxyDetailsCallback(status, rsp) {
        const { userDetails } = this.props;
        const { proxyRequestId, proxySource, requestType } = this.state;
        const { Id } = userDetails;
        const { ProxyRequestId, ReceiverUserId, Status } = rsp;
        this.setState({ status: Status && Status.toLowerCase() });

        //If the proxyrequestid is already mapped to the current user, dont do the ChangeRequestStatus
        // if ((Id !== ReceiverUserId && ProxyRequestId === proxyRequestId && Status.toLowerCase() === 'pending') ||  status === 'failure') {
            this.props.changeRequestStatus(proxyRequestId, proxySource, requestType, PROXY_PENDING, "", "", this.changeRequestPendingCallback);
            this.setState({ changeRequestStatusPending: true });
        // }  
    }

    toggleModal = () => {
        this.setState({
            showModal: !this.state.showModal
        })
    }

    onDeclineClick() {
        const { action, proxyRequestId, proxySource, proxyName } = this.state;
        const url = `/proxyrequest/decline/${proxyRequestId}/${proxySource}/${proxyName}`;
        this.acceptProxyTermsAndConditions(false); //Declined
        this.setState({ showV2Terms: false, url });
    }

    onAcceptClick() {
        const { action, proxyRequestId, proxySource, proxyName } = this.state;
        const url = `/proxyrequest/accept/${proxyRequestId}/${proxySource}/${proxyName}`;
        this.acceptProxyTermsAndConditions(true); //Accepted
        this.setState({ showV2Terms: false, url });
    }

    acceptProxyTermsAndConditions(isAccepted) {
        const { userDetails, age, myChartId, getProxyTermsAndConditionsAction, useTermsV2Endpoint } = this.props;
        const { requestType, proxySource, action } = this.state;
        const { userName, Email } = userDetails;
        //const age = getAge(dateOfBirth);
        const featureId = ProxyHelper.getFeatureId(requestType, proxySource, age, action);
        const versionId = useTermsV2Endpoint ? getProxyTermsAndConditionsAction.response[0].versionId : getProxyTermsAndConditionsAction.response.versionId;
        const logProxySource = ProxyHelper.getLogProxySource(proxySource);
        if (isAccepted) {
            logUI(`MBHWeb.UI.ProxyTermsV2.${logProxySource}.ProxyTermsAndConditions.Accepted`, new Date(), Tools.getURLPath());
        }
        else {
            logUI(`MBHWeb.UI.ProxyTermsV2.${logProxySource}.ProxyTermsAndConditions.Declined`, new Date(), Tools.getURLPath());
        }
        this.props.acceptProxyTermsAndConditions(featureId, isAccepted, userName, Email, myChartId, "", versionId); // Save proxy terms and conditions flag
    }

    getProxyTermsAndConditions() {
        const { age, getProxyTermsAndConditionsAction, useTermsV2Endpoint } = this.props;
        const { requestType, proxySource, action } = this.state;
        //const age = getAge(dateOfBirth);
        // Get featureId
        this.featureId = ProxyHelper.getFeatureId(requestType, proxySource, age, action);
        // Check if already called getProxyTermsAndConditions
        const fetchedProxyTermsAndConditions = useTermsV2Endpoint ? this.featureId !== null && getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response[0].featureId && getProxyTermsAndConditionsAction.response[0].featureId === this.featureId : this.featureId !== null && getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response.featureId && getProxyTermsAndConditionsAction.response.featureId === this.featureId;

        // if not called getProxyTermsAndConditions, call getProxyTermsAndConditions
        if (!fetchedProxyTermsAndConditions && this.featureId) {
            const logProxySource = ProxyHelper.getLogProxySource(proxySource);
            logUI(`MBHWeb.UI.ProxyTermsV2.${logProxySource}.GetProxyTermsAndConditions`, new Date(), Tools.getURLPath());
            this.props.getProxyTermsAndConditions(this.featureId);
        }
    }

    changeRequestPendingCallback(status, rsp) {
        const { proxyRequestId, proxySource } = this.state;
        if (status && status === 'failure') {
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.ProxyTermsV2.Request.V2.PendingStatus.Failure`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
            const errorMessage = this.getErrorMessage(status, rsp, true);
            this.setState({ errorMessage });
        }
    }

    getErrorMessage(status, rsp, isAnonymous = false) {
        let errorMessage = null;
        const { proxySource } = this.state;
        if (status === 'failure') {
            logUI(`MBHWeb.${ProxyHelper.getLogProxySource(proxySource)}.ProxyTermsV2.Request.V2.GetErrorMessage`, new Date(), Tools.getURLPath(), JSON.stringify({ response: rsp }));
            if (rsp && typeof rsp === "string") {
                switch (rsp) {
                    case "Internal Server Error":
                        errorMessage = DATEOFBIRTHINVALID;
                        break;
                    case "Invalid DOB":
                        errorMessage = DATEOFBIRTHINVALID;
                        break;
                    default:
                        errorMessage = rsp;
                        break;
                }
            }
            else if (rsp && rsp.message) {
                errorMessage = rsp.message;
            }
            else if (rsp && typeof (rsp) === "object" && rsp.errorCode) {
                errorMessage = rsp.errorMessage;
                if (rsp.errorCode &&
                    (rsp.errorCode.toLowerCase() === "granteralreadyhasaccess" ||
                        rsp.errorCode.toLowerCase() === "accountaccessexists"))
                {
                    this.setState({ showManageAccountAccess: true });
                }
            }
            else {
                errorMessage = DATEOFBIRTHINVALID;
            }
        }
        return errorMessage;
    }

    onRxLinked(dateOfBirth) {  
        //const { proxySource, requestType, proxyRequestId } = this.state;
        //this.props.changeRequestStatus(proxyRequestId, proxySource, requestType, PROXY_PENDING, "", "", this.validateDOB);
    }

    gotItCallback(event) {        
        const { proxySource, requestType, proxyRequestId } = this.state;
        this.props.changeRequestStatus(proxyRequestId, proxySource, requestType, PROXY_PENDING, "", "", this.changeRequestPendingCallback);
        this.setState({ pharmacyLinked: true });//just to making it to re-render.
    }

    render() {
        const { changeRequestStatusAction, hasMychartLogin, hasPharmacyLogin, enableProxyRequestV2, myChartRegistrationUrl, technicalHelpDeskNumber, technicalHelpDeskHours, getProxyTermsAndConditionsAction,
            enableProxyRXRequestAttestation, proxyDetails, useTermsV2Endpoint } = this.props;
        const { showV2Terms, errorMessage, url, proxySource, requestType, pharmacyLinked, status, changeRequestStatusPending, showManageAccountAccess } = this.state;
        const termsandconditions = useTermsV2Endpoint ? getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response[0].textToDisplay ? getProxyTermsAndConditionsAction.response[0].textToDisplay : "" : getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.response && getProxyTermsAndConditionsAction.response.textToDisplay ? getProxyTermsAndConditionsAction.response.textToDisplay : "";
        const isWaiting = changeRequestStatusPending ? (changeRequestStatusAction && changeRequestStatusAction.waiting && getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.waiting) : (getProxyTermsAndConditionsAction && getProxyTermsAndConditionsAction.waiting);
        const showTermsUponPendingStatusSuccess = changeRequestStatusPending ? (changeRequestStatusAction && changeRequestStatusAction.success && showV2Terms) : showV2Terms;
        const isProxyDetailsWaiting = proxyDetails && proxyDetails.waiting;
        const isChangeRequestStatusIsPending = !isProxyDetailsWaiting && changeRequestStatusAction && ((!changeRequestStatusAction.waiting && !changeRequestStatusAction.success && !errorMessage) || changeRequestStatusAction.waiting);//this is to check before the changerequeststatus call and immediately after proxydetails call waiting is over as it is having slight delay which is causing flickering of the UI.
        //debugger;
        return (isProxyDetailsWaiting || isChangeRequestStatusIsPending) ? <Spinner /> : (!errorMessage && (proxySource === RX) && enableProxyRXRequestAttestation && !pharmacyLinked && requestType.toLowerCase() === REQUEST ?
            <PharmacyNotFound onLinked={(dateOfBirth) => this.onRxLinked(dateOfBirth)} gotItCallback={this.gotItCallback} /> 
            : !errorMessage && (proxySource === EPIC) && enableProxyRequestV2 && !hasMychartLogin && requestType.toLowerCase() === REQUESTV2 ?
                <MyChartNotFound createAccountLink={myChartRegistrationUrl + "activation?s=1&option=Yes"} history={history} technicalHelpDeskHours={technicalHelpDeskHours} technicalHelpDeskNumber={technicalHelpDeskNumber} />
                :
                showV2Terms
                    ? <div className="container-fluid body-content proxy-terms-v2-comtainer">
                        <div className="row">
                            {!isWaiting
                                ? <React.Fragment>{showTermsUponPendingStatusSuccess
                                    ? <div className="col-12 maxWidth-content">
                                        <div className="row">
                                            <div className="col-12">
                                                <h1 className="page-heading">{mainHeading}</h1>
                                            </div>
                                            <div className="col-12">
                                                <h2 className="form-section-heading">
                                                    {subHeading}
                                                    <span> <a href="#" onClick={(e) => { e.preventDefault(); this.toggleModal(); }}>{"terms & conditions"}</a>
                                                        <Modal isOpen={this.state.showModal} toggle={() => this.toggleModal()} centered className="accept-terms-modal">
                                                            <div className="print-download-container">
                                                                <button className="btn btn-icon-only" title="Close" aria-label="Close" onClick={() => this.toggleModal()}><span className="icon-close modal-header-close-btn" /></button>
                                                            </div>
                                                            <AdultProxyAttestation heading={"Terms & Conditions"} termsandconditions={termsandconditions} featureId={this.featureId} />;
                                                                </Modal>
                                                    </span>
                                                </h2>

                                                <p>By giving access to Medical Records, you understand that the person you give access to will be able to view and request copies of all the information in your medical records, including but not limited to protected health information such as: </p>
                                                <ul className="angle-bullets">
                                                    <li>Mental health records (excluding psychotherapy notes)</li>
                                                    <li>Drug, alcohol or substance abuse records</li>
                                                    <li>Genetic information (including genetic test results)</li>
                                                    <li>HIV / AIDS test results/treatment</li>
                                                </ul>
                                                <p>Additionally, by giving access to Pharmacy, you understand that the person you give access to may be able to determine any underlying conditions or diagnoses contained in your medical records based off of prescription information.</p>
                                            </div>
                                            <div className="col-12">
                                                <div className="footer-buttons">
                                                    <input type="submit" className="btn btn-primary btn-dismiss" value="DECLINE" onClick={this.onDeclineClick} />
                                                    <input type="submit" className="btn btn-primary" value="AGREE AND CONTINUE" onClick={this.onAcceptClick} />
                                                </div>
                                                <Link className="btn text-btn" to={{ pathname: "/proxymanagement" }}>I'll do this later</Link>
                                            </div>
                                        </div>
                                    </div>
                                    : (changeRequestStatusAction && changeRequestStatusAction.error?
                                    <div className="col-12">
                                        <StatusBanner bannerMsg={"Sorry, we're unable to continue."} failedStatus>
                                            <p>{errorMessage}</p>
                                                {errorMessage === DATEOFBIRTHINVALID 
                                                    ? <p>You can also give access to your records <Link className="btn text-btn" to={{ pathname: "/proxymanagement" }}> here.</Link></p>
                                                    : showManageAccountAccess
                                                        ? <Link className="btn text-btn" to={{ pathname: "/proxymanagement" }}>Manage family accounts</Link>
                                                        : null
                                                }
                                        </StatusBanner>
                                        </div> : <Spinner />)
                                }</React.Fragment>
                                : <Spinner />}
                        </div>
                    </div>
                    : url && <Redirect to={{ pathname: url }} />);
    }
}

const mapStateToProps = (state) => {
    const requestData = state.common[types.PROXY_REQUEST_DATA];
    //const dob = requestData && requestData.pData && requestData.pData.dateOfBirth ? requestData.pData.dateOfBirth : "";
    return {
        proxyStatus: state.common[types.PROXY_STATUS],        
        getProxyTermsAndConditionsAction: state.common[types.PROXY_TERMS_AND_CONDITIONS],
        acceptProxyTermsAndConditionsAction: state.common[types.ACCEPT_PROXY_TERMS_AND_CONDITIONS],
        changeRequestStatusAction: state.common[types.REQUEST_PROXY_CHANGE_STATUS],
        proxyDetails: state.common[types.PROXY_DETAILS],
        hasMychartLogin: state.domain.hm,
        enableProxyRequestV2: state.session.serverData ? state.session.serverData.enableProxyRequestV2 : false,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours:"",
        history: state.session.history,
        myChartRegistrationUrl: state.session.serverData ? state.session.serverData.myChartRegistrationUrl : "",
        userDetails: state.sso.userDetails,
        myChartId: state.domain.mc,
        age: state.domain.age, 
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        enableProxyRXRequestAttestation: state.session.serverData ? state.session.serverData.enableProxyRXRequestAttestation : false,
        useTermsV2Endpoint: state.session.serverData ? state.session.serverData.useTermsV2Endpoint : false
    }
};

const mapDispatchToProps = (dispatch) => ({
    changeRequestStatus: (proxyRequestId, proxySource, requestType, status, reason, dateOfBirth, callback) =>
        dispatch({ type: types.REQUEST_PROXY_CHANGE_STATUS, data: { proxyRequestId, proxySource, requestType, status, reason, dateOfBirth }, callback }),
    getProxyDetails: (proxyRequestId, callback) =>
        dispatch({ type: types.PROXY_DETAILS, data: { proxyRequestId }, callback }),
    getProxyTermsAndConditions: (featureId, callback) =>
        dispatch({ type: types.PROXY_TERMS_AND_CONDITIONS, data: { featureId }, callback }),
    acceptProxyTermsAndConditions: (featureId, isAccepted, userName, email, loginId, proxyId, versionId, callback) =>
        dispatch({ type: types.ACCEPT_PROXY_TERMS_AND_CONDITIONS, data: { featureId, isAccepted, userName, email, loginId, proxyId, versionId }, callback })
});

export default connect(mapStateToProps, mapDispatchToProps)(ProxyTermsV2);